import vegSvg from "../images/foodLabels/veg.svg"
import spicySvg from "../images/foodLabels/spicy.svg";
import nutsSvg from "../images/foodLabels/nuts.svg";
import nonVegSvg from "../images/foodLabels/non-veg.svg";
import milkSvg from "../images/foodLabels/milk.svg";
import glutenFreeSvg from "../images/foodLabels/gluten-free.svg";
import fishSvg from "../images/foodLabels/fish.svg";
import eggSvg from "../images/foodLabels/egg.svg";
import twoXSpicySvg from "../images/foodLabels/2x-spicy.svg";

/**
 * Get menu item labels
 * @param menuItemLabels - Array of menu item labels
 * @returns Array of label icons
 */
const getMenuItemLabels = (menuItemLabels: string[]) => {
  let labelIcons: any[] = [];
  if (menuItemLabels.length > 0) {
    menuItemLabels.forEach((label) => {
      switch (label) {
        case "veg":
          labelIcons.push(vegSvg);
          break;
        case "non-veg":
          labelIcons.push(nonVegSvg);
          break;
        case "spicy":
          labelIcons.push(spicySvg);
          break;
        case "very-spicy":
          labelIcons.push(twoXSpicySvg);
          break;
        case "nuts":
          labelIcons.push(nutsSvg);
          break;
        case "milk":
          labelIcons.push(milkSvg);
          break;
        case "gluten-free":
          labelIcons.push(glutenFreeSvg);
          break;
        case "fish":
          labelIcons.push(fishSvg);
          break;
        case "egg":
          labelIcons.push(eggSvg);
          break;
      }
    });
  }
  return labelIcons;
};

//for listing food labels in the menu screen
const foodLabelDetails = [
  {
    id: 1,
    label: "Veg",
    icon: vegSvg,
  },
  {
    id: 2,
    label: "Non-Veg",
    icon: nonVegSvg,
  },
  {
    id: 3,
    label: "Spicy",
    icon: spicySvg,
  },
  {
    id: 4,
    label: "Very Spicy",
    icon: twoXSpicySvg,
  },
  {
    id: 5,
    label: "Nuts",
    icon: nutsSvg,
  },
  {
    id: 6,
    label: "Gluten Free",
    icon: glutenFreeSvg,
  },
  {
    id: 7,
    label: "Diary",
    icon: milkSvg,
  },
  {
    id: 8,
    label: "Seafood",
    icon: fishSvg,
  },
  {
    id: 9,
    label: "Egg",
    icon: eggSvg,
  },
]


export {
  getMenuItemLabels,
  foodLabelDetails,
}
